var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c("div", { staticClass: "uploadTip" }, [
                _vm._v(" 1、请先下载人房关系导入模板 ")
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownload }
                    },
                    [_vm._v("下载人房关系导入模板")]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "2、只能导入下载的模板文件，且模板内容需按提示填写"
                      )
                    ]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        name: "files",
                        "on-error": _vm.handleError,
                        "on-success": _vm.handleSuccess,
                        limit: 1,
                        "on-exceed": _vm.handleExceed,
                        action: _vm.uploadUrl,
                        "on-remove": _vm.handleRemove,
                        "before-remove": _vm.beforeRemove,
                        "before-upload": _vm.beforeUpload,
                        multiple: "",
                        "file-list": _vm.files
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "trigger", type: "primary" },
                              slot: "trigger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("button.chooseImportFile")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.isShowProgress
                ? _c("el-progress", {
                    attrs: {
                      percentage: _vm.percentage,
                      color: _vm.customColor
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.disBtn },
              on: { click: _vm.submitUpload }
            },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }